/* @flow */
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Translate, I18n } from 'react-redux-i18n'
import Slider from 'react-slick'
import _ from 'lodash'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faMapMarkerAlt from '@fortawesome/fontawesome-free-solid/faMapMarkerAlt'
import faHeartOutline from '@fortawesome/fontawesome-free-regular/faHeart'
import faHeart from '@fortawesome/fontawesome-free-solid/faHeart'
import Modal from 'react-responsive-modal'
import crypto from 'crypto'

import './style.css'
import { show360, getHomeResources, search, showLogin, showAlert } from '../../actions/global'
import CompoundInput from '../../components/CompoundInput'
import Preview from '../../components/Preview'
import ListItem from '../../components/ListItem'
import ScrollableList from '../../components/ScrollableList'
import NavArrow from '../../components/NavArrow'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import Button from '../../components/Button'
import { updateCouponStatus } from '../../actions/discount'
import { addToFavorite, removeFavorite } from '../../actions/activity'

class Home extends React.Component {
  state = {
    toSortBy: { label: I18n.t('sortByHot'), value: 'hot' },
    isAnnouncing: true,
    discountStage: 0,
    isRolling: false,
    coupon: null,
    resultDeg: 0,
  }

  _joinAccount = () => {
    const { account, discounts, coupons, showAlert, showLogin } = this.props
    if (!account) {
      showLogin()
    } else {
      if (discounts.length && _.keys(coupons).length && coupons[discounts[0].id].length) {
        showAlert(I18n.t('alreadyApplied'), null, 'warning')
      } else {
        this.setState({ discountStage: 1 })
      }
    }
  }

  _applyEvent = () => {
    const { discounts, coupons, showAlert } = this.props
    if (discounts.length && _.keys(coupons).length && coupons[discounts[0].id].length) {
      showAlert(I18n.t('alreadyApplied'), null, 'warning')
    } else {
      this.setState({ discountStage: 2 })
    }
  }

  _startLottery = () => {
    this.setState({ isRolling: true })
  }

  _stopLottery = () => {
    const { discounts, account, updateCouponStatus } = this.props
    const random = Math.random()
    let stopAngle = 0
    let coupon = null
    if (discounts.length) {
      const discount = discounts[0]
      const discountChoices = discounts[0].contents
      for (let i = 0; i < discountChoices.length; i++) {
        const item = discountChoices[i]
        if (random < (item.accumulated / 100)) {
          const randomOption = Math.floor(Math.random() * item.options.length)
          stopAngle = item.options[randomOption]
          coupon = {
            amount: item.amount,
            activatedDate: discount.activatedDate,
            expiredDate: discount.expiredDate,
            code: crypto.createHash('md5').update([account.email, item.amount, new Date()].join(';')).digest('hex'),
            active: true,
          }
          // To update db state
          updateCouponStatus(discount.id, coupon, account.uid)
          break
        }
      }
    }
    this.setState({ isRolling: false, discountStage: 3, coupon, resultDeg: stopAngle })
    setTimeout(() => this.setState({ showCoupon: true }), 750)
  }

  _shareToFB = () => {
    window.FB.ui({
      method: 'share',
      href: 'https://intocaerulus.com',
      quote: 'https://intocaerulus.com',
    }, function(response){})
  }

  // _serialize = params => Object.keys(params)
  //   .map(param => `${param}=${encodeURIComponent(params[param].trim())}`)
  //   .join('&');

  componentDidMount() {
    this.props.getHomeResources()
  }

  render() {
    const sliderConfig = {
      infinite: true,
      speed: 500,
      autoplay: true,
      prevArrow: <NavArrow icon={() => <i className="icon icon-chevron-dot-prev" />} />,
      nextArrow: <NavArrow icon={() => <i className="icon icon-chevron-dot-next" />} />,
    }

    // const sortBy = [
    //   { label: I18n.t('sortByHot'), value: 'hot' },
    //   { label: I18n.t('sortByUpdate'), value: 'update_at' },
    // ]
    const { account, announcements, locations, locale, shops, categories, activities, navigate, currency, addToFavorite, removeFavorite } = this.props
    const { toSortBy, isAnnouncing, discountStage, isRolling, resultDeg, coupon, showCoupon } = this.state

    const sortedLocations = _.orderBy(
      _.flatMap(locations,
        (location) => {
          if (!location.scenes) return []
          return location.scenes.map(
            (scene) => ({
              ...scene,
              location: location.name,
              divingMethod: scene.divingMethod.split(',').map((method) => I18n.t(method)).join('、')
            })
          )
        }
      ),
      [toSortBy.value],
      ['desc']
    )

    // Find favorites
    if (account) {
      const favoriteList = _.map(account.favorites, (value, key) => ({key, activityId: value.activityId}))
      _.map(activities, activity => {
        const favorite = _.find(favoriteList, { activityId: activity.id })
        activity.favoriteKey = favorite && favorite.key
        return activity
      })
    }

    // Grouping activities by tag
    const groups = _.map(categories, cate => {
      return {
        label: cate.label[locale],
        data: _.filter(activities, activity => _.includes(activity.tags, cate.value))
      }
    })

    return (
      <div className="container">
        <div className="slide-container">
          <Slider { ...sliderConfig }>
            { this.props.slides.map(slide => 
              <img key={slide.id}
                src={slide.url}
                alt={slide.id} />
            ) }
          </Slider>
          <div className="inputs">
            <div className="input-search list-item">
              <Translate value="homeInput" className="input-header" />
              <CompoundInput
                simpleSearch
                dataList={Object.values(locations)}
                displayFields={"name."+locale}
                placeholder={I18n.t('searchPlaceholder')}
                submit={(location, startDate, endDate, experience) => {
                  this.props.search(location, startDate, endDate, experience)
                  navigate('/search')
                }} />
            </div>
          </div>
        </div>
        <div className="content">
          <div className="recommend">
            <div className="recommend-header">
              {/* <i className="icon icon-circle-g">
                <span className="path1"></span><span className="path2"></span>
              </i> */}
              <Translate value="home360" />
              {/* <Select
                className="sort-by"
                clearable={false}
                name={'fSortBy'}
                searchable={false}
                value={_.find( sortBy, (option) => option.value === toSortBy.value )}
                onChange={(selected) => this.setState({ toSortBy: selected })}
                options={sortBy} /> */}
            </div>
            <ScrollableList
              list={sortedLocations}
              extractKey={(item, idx) => 'loc-'+idx}
              renderItem={(item) =>
                (
                  <Preview
                    locale={locale}
                    subtitle={item.location[locale]}
                    data={item}
                    funcIcon={<FontAwesomeIcon size="xs" color="#F29E4C" icon={faMapMarkerAlt} />}
                    onFuncIconClick={e => {
                      this.props.search(item.location)
                      navigate('/map')
                      e.stopPropagation()
                      e.preventDefault()
                    }}
                    options={[{
                      isRating: true,
                      title: 'divingDifficulty',
                      emptySymbol: <div className="icon icon-rating-none" />,
                      fullSymbol: <div className="icon icon-rating" />,
                      value: item.difficulty
                    }, {
                      title: 'divingMethod',
                      value: item.divingMethod
                    }]}
                    onClick={e => {
                      this.props.show360({ ...item })
                      e.stopPropagation()
                      e.preventDefault()
                    }}
                  />
                )
              }
            />
          </div>
          <div className="recommend">
            <div className="recommend-header">
              <Translate value="homeRecommend" />
            </div>
            <ScrollableList
              list={activities}
              extractKey={(item) => 'all-'+item.id}
              renderItem={(activity) => (
                <Preview
                  locale={locale}
                  subtitle={ shops.length ? _.filter(shops, ['id', activity.shopId])[0].name[locale] : '' }
                  data={activity}
                  funcIcon={account ? <FontAwesomeIcon size="xs" color="#F29E4C" icon={activity.favoriteKey ? faHeart : faHeartOutline} /> : null}
                  onFuncIconClick={e => {
                    if (activity.favoriteKey) {
                      removeFavorite({ key: activity.favoriteKey, account })
                    } else {
                      addToFavorite({ activityId: activity.id, account })
                    }
                    e.stopPropagation()
                    e.preventDefault()
                  }}
                  onClick={(e) => {
                    navigate('/activity/' + activity.id)
                    e.preventDefault()
                    e.stopPropagation()
                  }}
                  options={[{
                    value: currency.label.toUpperCase() + ' ' + Math.ceil((activity.packages ? activity.packages[0].price : activity.price) * currency.ratio * 100) / 100
                  }, {
                    isRating: true,
                    isRatingWithComments: true,
                    value: activity.rating
                  }]}
                  onHeaderClick={(e) => {
                    navigate('/shop/' + activity.shopId)
                    e.preventDefault()
                    e.stopPropagation()
                  }}
                />
              )}
            />
          </div>
          {
            _.map(groups, (group, idx) => (
              <div className="recommend" key={'group-'+idx}>
                <div className="recommend-header">
                  {group.label}
                </div>
                <ScrollableList
                  list={group.data}
                  extractKey={(item) => group.key+'-'+item.id}
                  renderItem={(activity) => {
                    const activityId = activity.id
                    return <Preview
                      locale={locale}
                      subtitle={ shops.length ? _.filter(shops, ['id', activity.shopId])[0].name[locale] : '' }
                      data={activity}
                      onClick={(e) => {
                        navigate('/activity/' + activityId)
                        e.preventDefault()
                        e.stopPropagation()
                      }}
                      options={[{
                        value: currency.label.toUpperCase() + ' ' + Math.ceil((activity.packages ? activity.packages[0].price : activity.price) * currency.ratio * 100) / 100
                      }, {
                        isRating: true,
                        isRatingWithComments: true,
                        value: activity.rating
                      }]}
                      onHeaderClick={(e) => {
                        navigate('/shop/' + activity.shopId)
                        e.preventDefault()
                        e.stopPropagation()
                      }}
                    />
                  }}
                />
              </div>
            ))
          }
        </div>
        <Modal
          open={!!announcements.length && isAnnouncing}
          onClose={() => this.setState({ isAnnouncing: false })}
          showCloseIcon={discountStage === 0}
          classNames={{ modal: 'announce-modal' }}
          closeOnOverlayClick={false}
        >
        {
          _.map(announcements, (announce, idx) => {
            let content = <img src="https://firebasestorage.googleapis.com/v0/b/caerulusvision.appspot.com/o/images%2Fevents%2Fevent-announcement.jpg?alt=media&token=247b23f4-559e-47a1-8037-072e174a5b81" alt="marketing event" />
            let actionBtnText = I18n.t('joinAccount')
            let actionBtnHandler = this._joinAccount
            let cancelBtn = <Button text={I18n.t('loginAccount')}
              onClick={this._joinAccount}
            />
            let stage = discountStage
            if (stage === 0 && account) {
              stage = 1
            }
            switch (stage) {
              case 1:
                content = <img src="https://firebasestorage.googleapis.com/v0/b/caerulusvision.appspot.com/o/images%2Fevents%2Fsummer-event.jpg?alt=media&token=8412b436-8d57-4d46-8375-2724939b8f98" alt="marketing event" />
                actionBtnText = I18n.t('applyEvent')
                actionBtnHandler = this._applyEvent
                cancelBtn = <Button text={I18n.t('nextTime')}
                  onClick={() => this.setState({ isAnnouncing: false })}
                />
                break
              case 2:
                content = <div className="turntable roulette-bg">
                  <img className="roulette" src="https://firebasestorage.googleapis.com/v0/b/caerulusvision.appspot.com/o/images%2Fevents%2Froulette.png?alt=media&token=f3ed1782-a6ef-4d47-937d-fffadc4ecd1f" alt="roulette" />
                  <img
                    className={"pointer" + (isRolling ? ' rolling' : (' rotate-' + resultDeg))}
                    src="https://firebasestorage.googleapis.com/v0/b/caerulusvision.appspot.com/o/images%2Fevents%2Fpointer.png?alt=media&token=281697fb-5bee-46d2-9845-c65f8e104be5"
                    alt="pointer"
                  />
                </div>
                actionBtnText = !isRolling ? I18n.t('startLottery') : I18n.t('stopLottery')
                actionBtnHandler = !isRolling ? this._startLottery : this._stopLottery
                cancelBtn = <Button text={I18n.t('nextTime')}
                  onClick={() => this.setState({ isAnnouncing: false })}
                />
                if (isRolling) {
                  cancelBtn = null
                }
                break
              case 3:
                content = <div className="roulette-result">
                  <div className={"turntable" + (!showCoupon && " roulette-bg") }>
                    {
                      !showCoupon ?
                      <div>
                        <img className="roulette" src="https://firebasestorage.googleapis.com/v0/b/caerulusvision.appspot.com/o/images%2Fevents%2Froulette.png?alt=media&token=f3ed1782-a6ef-4d47-937d-fffadc4ecd1f" alt="roulette" />
                        <img
                          className={"pointer" + (isRolling ? ' rolling' : (' rotate-' + resultDeg))}
                          src="https://firebasestorage.googleapis.com/v0/b/caerulusvision.appspot.com/o/images%2Fevents%2Fpointer.png?alt=media&token=281697fb-5bee-46d2-9845-c65f8e104be5"
                          alt="pointer"
                        />
                      </div> :
                      <div className="coupon">
                        <img src="https://firebasestorage.googleapis.com/v0/b/caerulusvision.appspot.com/o/images%2Fevents%2Fevent-ticket.jpg?alt=media&token=ef5be000-4c50-43d3-bac9-751f89c9d1d8" alt="coupon" />
                        <div className="coupon-amount">{[coupon.amount, I18n.t('ntd')].join(' ')}</div>
                        <div className="coupon-code">{coupon.code}</div>
                      </div>
                    }
                  </div>
                  <h3>{I18n.t('findAccountCoupon', { amount: coupon.amount })}</h3>
                </div>
                actionBtnText = I18n.t('shareToFB')
                actionBtnHandler = () => this._shareToFB()
                cancelBtn = <Button text={I18n.t('close')}
                  onClick={() => this.setState({ isAnnouncing: false })}
                />
                break
              default:
            }
            return <div key={'announcement-' + idx} className="discount-content">
              <Header title={announce.title} />
              <div>
                { content }
              </div>
              {
                <Button
                  type="action"
                  text={actionBtnText}
                  onClick={actionBtnHandler}
                />
              }
              {cancelBtn}
            </div>
          })
        }
        </Modal>
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    slides: state.global.slides,
    announcements: state.global.announcements,
    categories: state.global.categories,
    discounts: state.discount.all,
    coupons: state.discount.coupons,
    locations: state.scene.locations,
    shops: state.shop.shops,
    activities: state.activity.all,
    locale: state.i18n.locale,
    account: state.global.user,
    currency: state.global.currency,
  }
}

const mapDispatchToProps = dispatch => ({
  show360: (item) => dispatch(show360(item)),
  navigate: (location, args) => {
    window.scrollTo(0, 0)
    dispatch(push(location, args))
  },
  getHomeResources: () => dispatch(getHomeResources()),
  search: (location, startDate, endDate, experience) =>
  dispatch(search(location, startDate, endDate, experience)),
  showLogin: () => dispatch(showLogin()),
  showAlert: (message, title, type) => dispatch(showAlert(message, title, type)),
  updateCouponStatus: (discountId, coupon, uid) => dispatch(updateCouponStatus(discountId, coupon, uid)),
  addToFavorite: (shop) => dispatch(addToFavorite(shop)),
  removeFavorite: (payload) => dispatch(removeFavorite(payload)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home)


// WEBPACK FOOTER //
// ./src/containers/Home/index.js